import { useState } from 'react';
import { useMarketingData } from '../MarketingContext';


export default function DocumentsPage() {
  const { companies, documents, updateDocument } = useMarketingData();
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  const statusColors: Record<string, string> = {
    draft: 'bg-gray-100 text-gray-600', in_review: 'bg-amber-100 text-amber-700',
    approved: 'bg-green-100 text-green-700', published: 'bg-blue-100 text-blue-700', archived: 'bg-slate-100 text-slate-500',
  };
  const approvalColors: Record<string, string> = {
    not_submitted: 'bg-gray-100 text-gray-500', submitted: 'bg-blue-100 text-blue-700',
    in_review: 'bg-amber-100 text-amber-700', changes_requested: 'bg-red-100 text-red-700',
    approved: 'bg-green-100 text-green-700', rejected: 'bg-red-100 text-red-700',
  };

  const filtered = documents.filter(d => {
    if (search && !d.title.toLowerCase().includes(search.toLowerCase())) return false;
    if (filterStatus !== 'all' && d.status !== filterStatus) return false;
    return true;
  });

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-gray-900">Documentation Center</h1><p className="text-sm text-gray-500">Marketing strategies, guidelines, briefs, SOPs, and templates</p></div>
      <div className="flex gap-3 bg-white p-3 rounded-xl border border-gray-200">
        <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search documents..." className="flex-1 px-3 py-1.5 text-sm border border-gray-200 rounded-lg" />
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="text-sm border border-gray-200 rounded-lg px-3 py-1.5">
          <option value="all">All Status</option>{Object.keys(statusColors).map(s => <option key={s} value={s}>{s.replace('_', ' ')}</option>)}
        </select>
      </div>
      <div className="space-y-3">
        {filtered.map(d => {
          const co = companies.find(c => c.id === d.companyId);
          return (
            <div key={d.id} className="bg-white border border-gray-200 rounded-xl p-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-bold text-gray-900">{d.title}</div>
                  <div className="text-xs text-gray-500 mt-0.5">{d.type.replace('_', ' ')} · v{d.version} · {co?.name || 'Company-wide'}</div>
                  <div className="flex gap-2 mt-1.5">
                    <span className={`text-xs px-2 py-0.5 rounded-full ${statusColors[d.status]}`}>{d.status}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${approvalColors[d.approvalStatus]}`}>{d.approvalStatus.replace('_', ' ')}</span>
                    <span className="text-xs text-gray-400">Owner: {d.owner}</span>
                    <span className="text-xs text-gray-400">Updated: {d.updatedDate}</span>
                  </div>
                </div>
                <div className="flex gap-1.5">
                  {d.status === 'draft' && <button onClick={() => updateDocument(d.id, { status: 'in_review', approvalStatus: 'submitted' })} className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded-lg">Submit for Review</button>}
                  {d.status === 'in_review' && <button onClick={() => updateDocument(d.id, { status: 'approved', approvalStatus: 'approved' })} className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-lg">Approve</button>}
                  {d.status === 'approved' && <button onClick={() => updateDocument(d.id, { status: 'published' })} className="text-xs px-2 py-1 bg-emerald-100 text-emerald-700 rounded-lg">Publish</button>}
                </div>
              </div>
              <div className="flex flex-wrap gap-1 mt-2">{d.tags.map(t => <span key={t} className="text-[10px] px-1.5 py-0.5 bg-gray-100 text-gray-500 rounded">{t}</span>)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
